import { render, staticRenderFns } from "./ProductsDrawer.vue?vue&type=template&id=2f48c96a&"
import script from "./ProductsDrawer.vue?vue&type=script&lang=js&"
export * from "./ProductsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports